import React from "react";
import { SvgIcon, SvgIconProps } from '@mui/material';


const CheckIcon= (props: SvgIconProps) => {
	const { htmlColor } = props
	return <SvgIcon {...props} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="6" cy="6.5" r="5" fill={htmlColor} stroke={htmlColor} strokeWidth="2"/>
		<path d="M5.34519 7.36645L4.00882 6.03008C3.92701 5.94826
		3.82701 5.90735 3.70882 5.90735C3.59064 5.90735 3.4861
		5.95281 3.39519 6.04372C3.31337 6.12554 3.27246 6.22554
		3.27246 6.34372C3.27246 6.4619 3.31337 6.5619 3.39519
		6.64372L5.05882 8.32099C5.14064 8.40281 5.2361 8.44372 5.34519
		8.44372C5.45428 8.44372 5.54973 8.40281 5.63155 8.32099L8.89064
		5.0619C8.98155 4.97099 9.02701 4.86645 9.02701 4.74826C9.02701
		4.63008 8.98155 4.52554 8.89064 4.43463C8.79973 4.35281 8.69292
		4.31417 8.57019 4.31872C8.44746 4.32326 8.34519 4.36645 8.26337
		4.44826L5.34519 7.36645Z" fill="white"
		/></SvgIcon>
}

export default CheckIcon;
